import { CREATE_SESSION, MAGIC_SESSION, generateBFFUrl } from '@/configs/apiEndPoints';

import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import axiosInstance from './axiosConfig';
import dlv from 'dlv';

export const fetchSession = async (body: any, option: any): Promise<any> => {
  try {
    const response: any = await axiosInstance.post(generateBFFUrl(CREATE_SESSION), body, option);
    return response.data.session_id;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const fetchMagicSession = async (body: any): Promise<any> => {
  try {
    const response: any = await axiosInstance.post(generateBFFUrl(MAGIC_SESSION), body);
    return dlv(response, 'data.data', {});
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
